import React from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import utils from '../../../../../components/Organisms/Form/utils'

import Font from 'src/components/Core/Typography/Font/Font'
import InputFilesGroup from 'src/views/Forms/Components/InputFilesGroup/InputFilesGroup'
import Accordion from 'src/components/Organisms/Accordion/Accordion'
import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'
import { CORP_SEND_FILE_URL, DELIVERABLE_SEND_FILE_URL } from 'src/views/Pages/Onboarding/flowConfig'
import globalConsts from '../../globalConsts'
import { ConfigCompanyDetails } from '../CompanyDetails/types'
import { OptionsType } from 'src/components/Atoms/Dropdown/types'

const LabelSSIDetailsDocument = (
  <Font key='labelSSIDetailsDocument' ellipsis={false} bold={true} >
    {/* @ts-ignore:next-line */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.BankDetailsForm.visualOnly.labelSSIDetailsDocument'} />
  </Font>
)

const paymentSystemsAccordion = (
  <Accordion
    key='paymentSystemsAccordion'
    margin='0 0 16px 0'
    title={t('onboarding.forms.CorporateAccount.BankDetailsForm.visualOnly.paymentSystemsAccordion.title')}
    isOpen>
    {/* @ts-ignore */}
    {t('onboarding.forms.CorporateAccount.BankDetailsForm.visualOnly.paymentSystemsAccordion.content')}
  </Accordion>
)

const config = ({ currencies, timezones, formType }: ConfigCompanyDetails & {timezones: OptionsType[]} & {formType?: string}) => utils.injectTranslation({
  id: 'BankDetailsForm',
  path: 'onboarding.forms.CorporateAccount.BankDetailsForm.inputs',
  keysToRemove: ['visual', 'documentID'],
  content: [
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr 1fr',
        alignItems: 'flex-start',
        gridTemplateAreas:
          '\'currency . .\' \'beneficiaryAccountName beneficiaryAccountName ibanAccountNumber\' \'beneficiaryBankName beneficiaryBankAddress beneficiaryBankBICCode\' \'intermediaryBank intermediaryBank intermediaryBankBICCode\'',
        rowGap: '16px'
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'beneficiaryAccountName',
            removeLabelEllipsis: true,
            minHeight: '0',
            gridArea: 'beneficiaryAccountName',
            required: true
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'currency',
            removeLabelEllipsis: true,
            minHeight: '0',
            gridArea: 'currency',
            required: true
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: currencies,
            name: 'currency',
            label: 'onboarding.forms.CorporateAccount.BankDetailsForm.inputs.currency.label',
            placeholder: 'onboarding.forms.CorporateAccount.BankDetailsForm.inputs.currency.placeholder',
            marginInputWrapper: '0 0 8px 0',
            filter: true,
            required: true,
            ...props
          })
        },
        {
          componentType: 'input',
          props: {
            name: 'beneficiaryBankName',
            removeLabelEllipsis: true,
            minHeight: '0',
            gridArea: 'beneficiaryBankName',
            required: true
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'beneficiaryBankAddress',
            removeLabelEllipsis: true,
            minHeight: '0',
            gridArea: 'beneficiaryBankAddress',
            required: true,
            isTextarea: true,
            textAreaHeight: '48px',
            textAreaPointerEvents: 'auto',
            resize: 'none'
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'ibanAccountNumber',
            removeLabelEllipsis: true,
            minHeight: '0',
            gridArea: 'ibanAccountNumber',
            required: true
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'beneficiaryBankBICCode',
            removeLabelEllipsis: true,
            minHeight: '0',
            gridArea: 'beneficiaryBankBICCode',
            required: true
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'intermediaryBank',
            removeLabelEllipsis: true,
            minHeight: '0',
            gridArea: 'intermediaryBank',
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'intermediaryBankBICCode',
            removeLabelEllipsis: true,
            minHeight: '0',
            gridArea: 'intermediaryBankBICCode',
          },
        }
      ],
    },
    {
      componentType: 'grid',
      props: {
        marginBottom: 'auto',
        rowGap: '16px'
      },
      content: [
        {
          componentType: '',
          visualComponent: LabelSSIDetailsDocument
        },
        {
          componentType: 'input',
          props: {
            name: globalConsts.INPUT_FILES_CORPORATE_BANKDETAILS_SSIDOCUMENT,
          },
          custom: props => InputFilesGroup({
            inputMargin: '0 0 8px 0',
            inputLabel: t('onboarding.forms.CorporateAccount.BankDetailsForm.inputs.fileStandardSettlementInstructions.label'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: formType === 'Deliverable' ? DELIVERABLE_SEND_FILE_URL : CORP_SEND_FILE_URL
              }
            },
            step: '8',
            name: globalConsts.INPUT_FILES_CORPORATE_BANKDETAILS_SSIDOCUMENT,
            ...props
          }),
        },
        {
          componentType: 'accordion',
          visualComponent: paymentSystemsAccordion,
        },
        {
          componentType: 'input',
          props: {
            name: 'internationalPayments',
            removeLabelEllipsis: true,
            isTextarea: true,
            row: '3',
            required: true,
            textAreaPointerEvents: 'auto'
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'bankingSystems',
            removeLabelEllipsis: true,
            width: '50%',
            required: true
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'primaryBankName',
            removeLabelEllipsis: true,
            width: '50%',
            required: true
          },
        },
        {
          componentType: 'radioGroup',
          props: {
            name: 'isUsingTreasury',
            removeLabelEllipsis: true,
            minHeight: '0',
            marginBottom: '4px',
            dataList: [
              {
                id: 'isUsingTreasury1',
                label: t('onboarding.forms.CorporateAccount.BankDetailsForm.radioOptions.usingGroup'),
                value: 'usingGroup',
              },
              {
                id: 'isUsingTreasury2',
                label: t('onboarding.forms.CorporateAccount.BankDetailsForm.radioOptions.usingTreasury'),
                value: 'usingTreasury',
              },
            ],
            required: true,
          },
        },
        {
          componentType: 'radioGroup',
          props: {
            name: 'isPaymentProcessed',
            removeLabelEllipsis: true,
            minHeight: '0',
            margin: '0 0 4px 4%',
            dataList: [
              {
                id: 'isPaymentProcessed1',
                label: t('onboarding.forms.CorporateAccount.BankDetailsForm.radioOptions.locally'),
                value: 'locally',
              },
              {
                id: 'isPaymentProcessed2',
                label: t('onboarding.forms.CorporateAccount.BankDetailsForm.radioOptions.atTheGroup'),
                value: 'atTheGroup',
              },
            ],
            required: true,
          },
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'isInterCompanyFunding',
            removeLabelEllipsis: true,
            minHeight: '0',
            margin: '0 0 4px 4%',
            dataList: [
              {
                id: 'isInterCompanyFunding1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'isInterCompanyFunding2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'paymentApprovalProcess',
            removeLabelEllipsis: true,
            isTextarea: true,
            required: true,
            textAreaHeight: '50px',
            textAreaPointerEvents: 'auto'
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'releasePayments',
            removeLabelEllipsis: true,
            isTextarea: true,
            required: true,
            textAreaPointerEvents: 'auto'
          },
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'isTreaurydepartment',
            removeLabelEllipsis: true,
            dataList: [
              {
                id: 'isTreasurydepartment1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'isTreasurydepartment2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'treasurydepartmentReasons',
            removeLabelEllipsis: true,
            isTextarea: true,
            paddingLeft: '4%',
            required: true,
            textAreaHeight: '90px',
            textAreaPointerEvents: 'auto'
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'businessManageReleasePayments',
            removeLabelEllipsis: true,
            isTextarea: true,
            required: true,
            textAreaHeight: '50px',
            textAreaPointerEvents: 'auto'
          },
        },
        {
          componentType: 'input',
          transformType: 'transformJsonParse',
          props: {
            name: 'curenciesInternationalPayments',
            required: true
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: currencies,
            name: 'curenciesInternationalPayments',
            label: 'onboarding.forms.CorporateAccount.BankDetailsForm.inputs.curenciesInternationalPayments.label',
            placeholder: 'onboarding.forms.CorporateAccount.BankDetailsForm.inputs.curenciesInternationalPayments.placeholder',
            filter: true,
            multiple: true,
            required: true,
            ...props
          })
        },
        {
          componentType: 'grid',
          content: [
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '1fr 1fr'
              },
              content: [
                {
                  componentType: 'input',
                  transformType: 'time',
                  props: {
                    name: 'cutoffTimeForBusiness',
                    label: t('onboarding.forms.CorporateAccount.BankDetailsForm.inputs.cutoffTimeForBusiness.label'),
                    placeholder: t('onboarding.forms.CorporateAccount.BankDetailsForm.inputs.cutoffTimeForBusiness.placeholder'),
                    removeLabelEllipsis: true,
                    type: 'time',
                    resize: 'none',
                    marginBottom: '0',
                    flexProperties: {
                      flexDirection: 'column',
                      justifyContent: 'flex-end'
                    },
                    required: true
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'timezonesDropdown',
                    removeLabelEllipsis: true,
                    type: 'time',
                    resize: 'none',
                    step: '3600',
                    required: true,
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: timezones,
                    name: 'timezonesDropdown',
                    label: 'onboarding.forms.CorporateAccount.BankDetailsForm.inputs.timezonesDropdown.label',
                    placeholder: 'onboarding.forms.CorporateAccount.BankDetailsForm.inputs.timezonesDropdown.placeholder',
                    alignItems: 'flex-end',
                    required: true,
                    filter: true,
                    ...props
                  })
                },
              ]
            }

          ]
        },
        {
          componentType: 'input',
          props: {
            name: 'openExchanges',
            removeLabelEllipsis: true,
            width: '50%',
            required: true
          },
        },
      ]
    }
  ],
})

export default config
